// src/app/components/full-loader/full-loader.component.ts
import { Component } from '@angular/core';
import { LoaderService } from 'src/app/services/loader.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-full-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './full-loader.component.html',
  styleUrls: ['./full-loader.component.scss'],
})
export class FullLoaderComponent {
  constructor(public loader: LoaderService) {}
}
